import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from './config';

// Upload file
export const uploadFile = async (file: File, path: string) => {
  try {
    // Enforce client-side size/content checks to match rules
    const MAX_SIZE = 5 * 1024 * 1024; // 5MB
    if (file.size > MAX_SIZE) {
      return { success: false, error: 'File exceeds size limit of 5MB' };
    }

    const storageRef = ref(storage, `${path}/${Date.now()}_${file.name}`);
    // provide contentType metadata so storage rules that check request.resource.contentType pass
    const metadata = { contentType: file.type || 'application/octet-stream' } as any;
    const snapshot = await uploadBytes(storageRef, file, metadata);
    const downloadURL = await getDownloadURL(snapshot.ref);

    return {
      success: true,
      url: downloadURL,
      path: snapshot.ref.fullPath
    };
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

// Upload multiple files
export const uploadMultipleFiles = async (files: File[], path: string) => {
  try {
    const uploadPromises = files.map(file => uploadFile(file, path));
    const results = await Promise.all(uploadPromises);

    const successfulUploads = results.filter((result: any) => result.success);
    const failedUploads = results.filter((result: any) => !result.success);

    return {
      success: true,
      uploadedFiles: successfulUploads,
      failedFiles: failedUploads
    };
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

// Delete file
export const deleteFile = async (filePath: string) => {
  try {
    const fileRef = ref(storage, filePath);
    await deleteObject(fileRef);
    return { success: true };
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};